import { render, staticRenderFns } from "./ProfileCompleteness.vue?vue&type=template&id=4d7067dc&"
import script from "./ProfileCompleteness.vue?vue&type=script&lang=js&"
export * from "./ProfileCompleteness.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports